import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import Footer from "src/Component/Footer";
import Navbar from "src/Component/Navbar";
import Universitybanner from "./University/Universitybanner";
import {
  AbuDhabiBanner,
  AdelaideBanner,
  AjmanBanner,
  ALAinBanner,
  AnuBanner,
  AUOTBanner,
  AURAKBanner,
  AUSBanner,
  BirminghamBanner,
  BristolBanner,
  BrockBanner,
  CalgeryBanner,
  CaliforniaBanner,
  ChicagoBanner,
  ColoradoBanner,
  CSBanner,
  CUDBanner,
  DalhousieBanner,
  DBSBanner,
  DCUBanner,
  DurhamBanner,
  EdinburghBanner,
  EIOTBanner,
  ERABanner,
  FUBBanner,
  GlasgowBanner,
  HeidelbergUniversityBanner,
  HumboldtUniversityBanner,
  IEDBanner,
  IllinoisBanner,
  ImperialBanner,
  JCBanner,
  khalifaBanner,
  LeedsBanner,
  LiverpoolBanner,
  LMUBanner,
  LUniversityBanner,
  MacquarieBanner,
  MDISBanner,
  MelbourneBanner,
  MITBanner,
  MonashBanner,
  MUBanner,
  MUniversityBanner,
  NTUBanner,
  NUSBanner,
  PDMilanoBanner,
  PennsylvaniaBanner,
  QueenMaryBanner,
  QueenslandBanner,
  RCHEBanner,
  RCSIBanner,
  RLSBanner,
  RRUBanner,
  RWTHBanner,
  SIMGEBanner,
  SMBanner,
  SouthamptonBanner,
  StanfordBanner,
  SUBanner,
  SUTDBanner,
  SydneyBanner,
  TCDublinBanner,
  TechnologySydneyBanner,
  TMUBanner,
  TorontoBanner,
  TrentBanner,
  TrinityBanner,
  TUDublinBanner,
  UAEUBanner,
  UCanterburyBanner,
  UCDublinBanner,
  UCICBanner,
  UDBBanner,
  UDLBanner,
  UDMBanner,
  UDNBanner,
  UDSBanner,
  UGABanner,
  UniversityOfDubaiBanner,
  UNSWBanner,
  UOABanner,
  UOBolognaBanner,
  UOCorkBanner,
  UOFBanner,
  UOFlorenceBanner,
  UOGalwayBanner,
  UOGBanner,
  UOLimerickBanner,
  UOMBanner,
  UOMilanBanner,
  UONaplesBanner,
  UOPaduaBanner,
  UOPisaBanner,
  UOtagoBanner,
  UOTBanner,
  UOTurinBanner,
  UOWBanner,
  UPPSBanner,
  UPSBanner,
  UPSLBanner,
  UtahBanner,
  VCCBanner,
  VUOWBanner,
  WaterlooBanner,
  WesternaustraliaBanner,
  WindsorBanner,
  WisconsinBanner,
  YeshivaBanner,
  ZayedUniversityBanner,
} from "./UniversityJson/UniversityBanner";
import LetsGetStarted from "src/Component/LetsGetStarted";
import UniversityInfo from "./University/UniversityInfo";
import {
  AbuDhabiInfo,
  AdelaideInfo,
  AjmanInfo,
  ALAinInfo,
  ANUInfo,
  AURAKInfo,
  AUSInfo,
  AUTInfo,
  BirminghamInfo,
  BristolInfo,
  BrockInfo,
  CalgaryInfo,
  CaliforniaInfo,
  CanterburyInfo,
  ChicagoInfo,
  ColoradoInfo,
  CSInfo,
  CUDInfo,
  DalhousieInfo,
  DBSInfo,
  DCUInfo,
  DurhamInfo,
  EdinburghInfo,
  EITInfo,
  ERAInfo,
  FUBInfo,
  GlasgowInfo,
  HeidelbergUniversityInfo,
  HumboldtUniversityInfo,
  IEDInfo,
  IllinoisInfo,
  ImperialInfo,
  JCInfo,
  KhalifaInfo,
  LeedsInfo,
  LincolnInfo,
  LiverpoolInfo,
  LMUInfo,
  MacquarieInfo,
  MasseyInfo,
  MDISInfo,
  MelbourneInfo,
  MITInfo,
  MonashInfo,
  MUInfo,
  NTUInfo,
  NUSInfo,
  OtagoInfo,
  PDMilanoiInfo,
  PennsylvaniaInfo,
  QueenMaryInfo,
  QueenslandInfo,
  RCOHInfo,
  RCSInfo,
  RLSInfo,
  RRUInfo,
  RWTHInfo,
  SIMGEInfo,
  SMInfo,
  SouthamptonInfo,
  StanfordInfo,
  SUInfo,
  SUTDInfo,
  SydneyInfo,
  TCDublinInfo,
  TorontoInfo,
  TrentInfo,
  TrinityInfo,
  TUDublinInfo,
  TUMInfo,
  UAEUInfo,
  UCDublinInfo,
  UCICInfo,
  UDBInfo,
  UDLInfo,
  UDMInfo,
  UDNInfo,
  UDSInfo,
  UGAInfo,
  UniboInfo,
  UniversityOfDubaiInfo,
  UNSWInfo,
  UoAInfo,
  UOCorkInfo,
  UOFInfo,
  UOFlorenceInfo,
  UOGalwayInfo,
  UOGInfo,
  UOLimerickInfo,
  UOMilanInfo,
  UOMInfo,
  UONaplesInfo,
  UOPaduaInfo,
  UOPisaInfo,
  UOTInfo,
  UOTurinInfo,
  UPPSInfo,
  UPSInfo,
  UPSLInfo,
  UtahInfo,
  UTSInfo,
  UWAInfo,
  VCCInfo,
  VUWInfo,
  WaikatoInfo,
  WaterlooInfo,
  WindsorInfo,
  WisconsinInfo,
  YeshivaInfo,
  ZayedUniversityInfo,
} from "./UniversityJson/UniversityInfoData";
import WhyChooseUniversity from "./University/WhyChooseUniversity";
import {
  AbuDhabiRankings,
  AdelaideRankings,
  AjmanRankings,
  ALAinRankings,
  ANURankings,
  AucklanduniversityRankings,
  AURAKRankings,
  AUSRankings,
  BirminghamRankings,
  BristolChoose,
  BrockRankings,
  CalgeryRankings,
  CaliforniaChoose,
  CanterburyuniversityRankings,
  ChicagoChoose,
  ColoradoChoose,
  CSRankings,
  CUDRankings,
  DalhousieRankings,
  DBSChooseUs,
  DCUChooseUs,
  DurhamRankings,
  EasternpolytechnicRankings,
  EdinburghRankings,
  ERARankings,
  FUBRankings,
  GlasgowRankings,
  HeidelbergUniversityRankings,
  HumboldtUniversityRankings,
  IEDChooseUs,
  IllinoisChoose,
  ImperialRankings,
  JCRankings,
  KhalifaRankings,
  LeedsRankings,
  LincolnuniversityRankings,
  LiverpoolRankings,
  LMURankings,
  MacquarieRankings,
  MDISRankings,
  MelbourneRankings,
  MITChoose,
  MonashRankings,
  MUChooseUs,
  NTURankings,
  NUSRankings,
  OtagouniversityRankings,
  PDMilanoChooseUs,
  PennsylvaniaChoose,
  QueenMaryRankings,
  QueenslandRankings,
  RCHERankings,
  RCSChooseUs,
  RLSChooseUs,
  RRURankings,
  RWTHRankings,
  SIMGERankings,
  SMRankings,
  SouthamptonRankings,
  StanfordChoose,
  SURankings,
  SUTDRankings,
  SydneyRankings,
  TCDublinChooseUs,
  TorontoRankings,
  trentRankings,
  TrinityRankings,
  TUDublinChooseUs,
  TUMRankings,
  UAEURankings,
  UCDublinChooseUs,
  UCICRankings,
  UDBRankings,
  UDLRankings,
  UDMRankings,
  UDNRankings,
  UDSRankings,
  UGARankings,
  UniversityAucklandRankings,
  universityMasseyRankings,
  UniversityOfDubaiRankings,
  UNSWRankings,
  UOBolognaChooseUs,
  UOCorkChooseUs,
  UOFlorenceChooseUs,
  UOFRankings,
  UOGalwayChooseUs,
  UOGRankings,
  UOLimerickChooseUs,
  UOMilanChooseUs,
  UOMRankings,
  UONaplesChooseUs,
  UOPaduaChooseUs,
  UOPisaChooseUs,
  UOTRankings,
  UOTurinChooseUs,
  UPPSRankings,
  UPSLRankings,
  UPSRankings,
  UtahChoose,
  UTSRankings,
  VCCProfile,
  VictoriauniversityRankings,
  WaikatouniversityRankings,
  WaterlooRankings,
  WesternAustraliaRankings,
  WindsorRankings,
  WisconsinChoose,
  YeshivaChoose,
  ZayedUniversityRankings,
} from "./UniversityJson/UniversityChoose";
import UniversityFeeStructure from "./University/UniversityFeeStructure";
import {
  AbutDhabiFeeStructure,
  AdelaideFeeStructure,
  AjmanFeeStructure,
  AlAinFeeStructure,
  ANUFeeStructure,
  AUOTFeeStructure,
  AURAKFeeStructure,
  AUSFeeStructure,
  BirminghamFeeStructure,
  BristolFeeStructure,
  BrockFeeStructure,
  CalgeryFeeStructure,
  CaliforniaFeeStructure,
  ChicagoFeeStructure,
  ColoradoFeeStructure,
  CSFeeStructure,
  CUDFeeStructure,
  DalhousieFeeStructure,
  DBSFeeStructure,
  DCUFeeStructure,
  DurhamFeeStructure,
  EdinburghFeeStructure,
  EIOTFeeStructure,
  ERAFeeStructure,
  FUBFeeStructure,
  GlasgowFeeStructure,
  HeidelbergUniversityFeeStructure,
  HumboldtUniversityFeeStructure,
  IEDFeeStructure,
  IllinoisFeeStructure,
  ImperialFeeStructure,
  JCFeeStructure,
  KhalifaFeeStructure,
  LeedsFeeStructure,
  LiverpoolFeeStructure,
  LMUFeeStructure,
  LUniversityFeeStructure,
  MacquarieFeeStructure,
  MDISFeeStructure,
  MelbourneFeeStructure,
  MITFeeStructure,
  MonashFeeStructure,
  MUFeeStructure,
  MUniversityFeeStructure,
  NTUFeeStructure,
  NUSFeeStructure,
  PDMilanoFeeStructure,
  PennsylvaniaFeeStructure,
  QueenMaryFeeStructure,
  RCHEFeeStructure,
  RCSFeeStructure,
  RLSFeeStructure,
  RRUFeeStructure,
  RWTHFeeStructure,
  SIMGEFeeStructure,
  SMFeeStructure,
  SouthamptonFeeStructure,
  StanfordFeeStructure,
  SUFeeStructure,
  SUTDFeeStructure,
  SydneyFeeStructure,
  TCDublinFeeStructure,
  TorontoFeeStructure,
  TrentFeeStructure,
  TrinityFeeStructure,
  TUDublinFeeStructure,
  TUMFeeStructure,
  UAEUFeeStructure,
  UCanterburyFeeStructure,
  UCCorkFeeStructure,
  UCDublinFeeStructure,
  UCICFeeStructure,
  UDBFeeStructure,
  UDLFeeStructure,
  UDMFeeStructure,
  UDNFeeStructure,
  UDSFeeStructure,
  UGAFeeStructure,
  UniversityOfDubaiFeeStructure,
  UNSWFeeStructure,
  UOAFeeStructure,
  UOBolognaFeeStructure,
  UOFFeeStructure,
  UOFlorenceFeeStructure,
  UOGalwayFeeStructure,
  UOGFeeStructure,
  UOLimerickFeeStructure,
  UOMFeeStructure,
  UOMilanFeeStructure,
  UONaplesFeeStructure,
  UOPaduaFeeStructure,
  UOPisaFeeStructure,
  UOtagoFeeStructure,
  UOTFeeStructure,
  UOTurinFeeStructure,
  UOWFeeStructure,
  UPPSFeeStructure,
  UPSFeeStructure,
  UPSLFeeStructure,
  UQFeeStructure,
  UtahFeeStructure,
  UTSFeeStructure,
  VCCFeeStructure,
  VUOWFeeStructure,
  WaterlooFeeStructure,
  WesternAustraliaFeeStructure,
  WindsorFeeStructure,
  WisconsinFeeStructure,
  YeshivaFeeStructure,
  ZayedUniversityFeeStructure,
} from "./UniversityJson/UniversityFeeStructure";
import UniversityScholarship from "./University/UniversityScholarship";
import {
  AdelaideScholarships,
  ANUScholarships,
  BirminghamScholarships,
  BristolScholarships,
  CaliforniaScholarships,
  ColoradoScholarships,
  GlasgowScholarships,
  ImperialScholarships,
  LeedsScholarships,
  MacquarieScholarships,
  MelbourneScholarships,
  MonashScholarships,
  QueenslandScholarships,
  SydneyScholarships,
  UNSWScholarships,
  UtahScholarships,
  UTSScholarships,
  UWAScholarships,
  WisconsinScholarships,
  YeshivaScholarships,
  TrentScholarships,
  TrinityScholarships,
  RoyalScholarships,
  WaterlooScholarships,
  CalgeryScholarships,
  DalhousieScholarships,
  BrockScholarships,
  WindsorScholarships,
  VCCScholarships,
  TorontoScholarships,
  LiverpoolScholarships,
  EdinburghScholarships,
  SouthamptonScholarships,
  DurhamScholarships,
  QueenMaryScholarships,
  IllinoisScholarships,
  StanfordScholarships,
  PennsylvaniaScholarships,
  ChicagoScholarships,
  MITScholarships,
  LMUScholarships,
  TUMScholarships,
  HeidelbergUniversityScholarships,
  HumboldtUniversityScholarships,
  FUBScholarships,
  RWTHScholarships,
  UOFScholarships,
  UOTScholarships,
  UOMScholarships,
  UOGScholarships,
  UPSLScholarships,
  UPSScholarships,
  SUScholarships,
  UGAScholarship,
  UDSScholarships,
  UDMScholarships,
  UDLScholarships,
  UDNScholarships,
  UDBScholarships,
  UPPSScholarships,
  PDMilanoScholarships,
  UOMilanScholarships,
  UOBolognaScholarships,
  UOFlorenceScholarships,
  UOTurinScholarships,
  UOPaduaScholarships,
  RLSScholarships,
  UONaplesScholarships,
  UOPisaScholarships,
  IEDScholarships,
  TCDublinScholarships,
  UCDublinScholarships,
  UOCorkScholarships,
  UOGalwayScholarships,
  DCUScholarships,
  UOLimerickScholarships,
  MUScholarships,
  TUDublinScholarships,
  DBSScholarships,
  RCSScholarships,
  AucklandScholarships,
  MasseyScholarships,
  WaikatoScholarships,
  VictoriaScholarships,
  CanterburyScholarships,
  OtagoScholarships,
  AUTScholarships,
  LincolnScholarships,
  EITScholarships,
  UCScholarships,
  UniversityOfDubaiScholarships,
  ZayedUniversityScholarships,
  AlAinScholarships,
  AUSScholarships,
  KhalifaScholarships,
  UAEUScholarships,
  AURAKScholarships,
  AbuDhabiScholarships,
  AjmanScholarships,
  CUDScholarships,
  NUSScholarships,
  NTUScholarships,
  SUTDScholarships,
  SMScholarships,
  JCScholarships,
  MDISScholarships,
  SIMGEScholarships,
  RCHEScholarships,
  ERAScholarships,
  CSScholarships,
} from "./UniversityJson/UniversityScholarship";
import UniversityKnowMore from "./University/UniversityKnowMore";
import {
  AbuDhabiKnowMore,
  AdelaideKnowMore,
  AjmanKnowMore,
  AlAinKnowMore,
  ANUKnowMore,
  AucklandKnowMore,
  AURAKKnowMore,
  AUSKnowMore,
  AUTKnowMore,
  BirminghamKnowMore,
  BristolKnowMore,
  BrockKnowMore,
  CalgaryKnowMore,
  CaliforniaKnowMore,
  CanterburyKnowMore,
  ChicagoKnowMore,
  ColoradoKnowMore,
  CUDKnowMore,
  CurtinSingaporeKnowMore,
  DalhousieKnowMore,
  DBSKnowMore,
  DCUKnowMore,
  DurhamKnowMore,
  EdinburghKnowMore,
  EITKnowMore,
  ERAUAsiaKnowMore,
  FUBerlinKnowMore,
  GlasgowKnowMore,
  HeidelbergUniversityKnowMore,
  HumboldtUniversityKnowMore,
  IEDKnowMore,
  IllinoisKnowMore,
  ImperialKnowMore,
  JCUNowMore,
  KhalifaKnowMore,
  LeedsKnowMore,
  LincolnKnowMore,
  LiverpoolKnowMore,
  LMUKnowMore,
  MacquarieKnowMore,
  MasseyKnowMore,
  MDISKnowMore,
  MelbourneKnowMore,
  MITKnowMore,
  MonashKnowMore,
  MUKnowMore,
  NTUKnowMore,
  NUSKnowMore,
  OtagoKnowMore,
  PDMilanoKnowMore,
  PennsylvaniaKnowMore,
  QueenMaryKnowMore,
  QueenslandKnowMore,
  RafflesKnowMore,
  RCSIKnowMore,
  RLSKnowMore,
  RoyalRoadsKnowMore,
  RWTHAachenKnowMore,
  SIMKnowMore,
  SMUKnowMore,
  SouthamptonKnowMore,
  StanfordKnowMore,
  SUKnowMore,
  SUTDKnowMore,
  SydneyKnowMore,
  TCDublinKnowMore,
  TorontoKnowMore,
  TrentKnowMore,
  TrinityKnowMore,
  TUDublinKnowMore,
  TUMKnowMore,
  UAEUKnowMore,
  UCDublinKnowMore,
  UCICKnowMore,
  UDBKnowMore,
  UDLKnowMore,
  UDMKnowMore,
  UDNKnowMore,
  UDSKnowMore,
  UGAKnowMore,
  UniversityOfDubaiKnowMore,
  UNSWKnowMore,
  UOBolognaKnowMore,
  UOCorkKnowMore,
  UOFKnowMore,
  UOFlorenceKnowMore,
  UOGalwayKnowMore,
  UOGKnowMore,
  UOLimerickKnowMore,
  UOMilanKnowMore,
  UOMKnowMore,
  UONaplesKnowMore,
  UOPaduaKnowMore,
  UOPisaKnowMore,
  UOTKnowMore,
  UOTurinKnowMore,
  UPPSKnowMore,
  UPSKnowMore,
  UPSLKnowMore,
  UtahKnowMore,
  UTSKnowMore,
  VCCKnowMore,
  VictoriaKnowMore,
  WaikatoKnowMore,
  WaterlooKnowMore,
  WesternAustraliaKnowMore,
  WindsorKnowMore,
  WisconsinKnowMore,
  YeshivaKnowMore,
  ZayedUniversityKnowMore,
} from "./UniversityJson/UniversityKnowMore";
import UniversityRecruiters from "./University/UniversityRecruiters";
import {
  AURAKRecruiter,
  AUSRecruiter,
  AUTRecruiter,
  AbutDhabiRecruiter,
  AdelaideRecruiter,
  AjmanRecruiter,
  AlAinFRecruiter,
  AnuRecruiter,
  AucklandRecruiter,
  BirminghamRecruiter,
  BristolRecruiter,
  BrockRecruiter,
  CSRecruiters,
  CUDRecruiter,
  CalgeryRecruiter,
  CaliforniaRecruiter,
  CanterburyRecruiter,
  ChicagoRecruiter,
  ColoradoRecruiter,
  DBSRecruiter,
  DCURecruiter,
  DalhousieRecruiter,
  DurhamRecruiter,
  EITRecruiter,
  ERARecruiters,
  EdinburghRecruiter,
  FUBRecruiter,
  GlasgowRecruiter,
  HeidelbergUniversityRecruiter,
  HumboldtUniversityRecruiter,
  IEDRecruiter,
  IllinoisRecruiter,
  JCRecruiters,
  KhalifaRecruiter,
  LMURecruiter,
  LeedsRecruiter,
  LincolnRecruiter,
  LiverpoolRecruiter,
  MDISRecruiters,
  MITRecruiter,
  MURecruiter,
  MacquarieRecruiter,
  MasseyRecruiter,
  MelbourneRecruiter,
  MonashRecruiter,
  NTURecruiters,
  NUSRecruiters,
  OtagoRecruiter,
  PDMilanoRecruiter,
  PennsylvaniaRecruiter,
  QueenMaryRecruiter,
  QueenslandRecruiter,
  RCHERecruiters,
  RCSIRecruiter,
  RLSRecruiter,
  RRURecruiter,
  RWTHRecruiter,
  SIMGERecruiters,
  SMRecruiters,
  SURecruiter,
  SUTDRecruiters,
  SouthamptonRecruiter,
  StanfordRecruiter,
  SydneyRecruiter,
  TCDublinRecruiter,
  TUDublinRecruiter,
  TUMRecruiter,
  TorontoRecruiter,
  TrentRecruiter,
  TrinityRecruiter,
  UAEURecruiter,
  UCDublinRecruiter,
  UCRecruiters,
  UDBRecruiter,
  UDLRecruiter,
  UDMRecruiter,
  UDNRecruiter,
  UDSRecruiter,
  UGARecruiter,
  UNSWRecruiter,
  UOBolognaRecruiter,
  UOCorkRecruiter,
  UOFRecruiter,
  UOFlorenceRecruiter,
  UOGRecruiter,
  UOGalwayRecruiter,
  UOLimerickRecruiter,
  UOMRecruiter,
  UOMilanRecruiter,
  UONaplesRecruiter,
  UOPaduaRecruiter,
  UOPisaRecruiter,
  UOTRecruiter,
  UOTurinRecruiter,
  UPPSRecruiter,
  UPSLRecruiter,
  UPSRecruiter,
  UniversityOfDubaiRecruiter,
  UtahRecruiter,
  UtsRecruiter,
  VCCRecruiter,
  VictoriaRecruiter,
  WaikatoRecruiter,
  WaterlooRecruiter,
  WesternAustraliaRecruiter,
  WindsorRecruiter,
  YeshivaRecruiter,
  ZayedUniversityRecruiter,
  imperialRecruiter,
  wisconsinRecruiter,
} from "./UniversityJson/UniversityRecruiters";
import BackRouteContainer from "src/Component/grid-component/BackButtonComponent";
import logo from "../asset/backuniversity.png";

const jsonData = [
  {
    pathname: "california",
    banner: CaliforniaBanner,
    info: CaliforniaInfo,
    choose: CaliforniaChoose,
    fee: CaliforniaFeeStructure,
    scholarship: CaliforniaScholarships,
    know: CaliforniaKnowMore,
    recruiters: CaliforniaRecruiter,
  },
  {
    pathname: "wisconsin",
    banner: WisconsinBanner,
    info: WisconsinInfo,
    choose: WisconsinChoose,
    fee: WisconsinFeeStructure,
    scholarship: WisconsinScholarships,
    know: WisconsinKnowMore,
    recruiters: wisconsinRecruiter,
  },
  {
    pathname: "yeshiva",
    banner: YeshivaBanner,
    info: YeshivaInfo,
    choose: YeshivaChoose,
    fee: YeshivaFeeStructure,
    scholarship: YeshivaScholarships,
    know: YeshivaKnowMore,
    recruiters: YeshivaRecruiter,
  },
  {
    pathname: "utah",
    banner: UtahBanner,
    info: UtahInfo,
    choose: UtahChoose,
    fee: UtahFeeStructure,
    scholarship: UtahScholarships,
    know: UtahKnowMore,
    recruiters: UtahRecruiter,
  },

  {
    pathname: "colorado",
    banner: ColoradoBanner,
    info: ColoradoInfo,
    choose: ColoradoChoose,
    fee: ColoradoFeeStructure,
    scholarship: ColoradoScholarships,
    Know: ColoradoKnowMore,
    recruiters: ColoradoRecruiter,
  },

  {
    pathname: "illinois",
    banner: IllinoisBanner,
    info: IllinoisInfo,
    choose: IllinoisChoose,
    fee: IllinoisFeeStructure,
    scholarship: IllinoisScholarships,
    know: IllinoisKnowMore,
    recruiters: IllinoisRecruiter,
  },
  {
    pathname: "stanford",
    banner: StanfordBanner,
    info: StanfordInfo,
    choose: StanfordChoose,
    fee: StanfordFeeStructure,
    scholarship: StanfordScholarships,
    know: StanfordKnowMore,
    recruiters: StanfordRecruiter,
  },
  {
    pathname: "pennsylvania",
    banner: PennsylvaniaBanner,
    info: PennsylvaniaInfo,
    choose: PennsylvaniaChoose,
    fee: PennsylvaniaFeeStructure,
    scholarship: PennsylvaniaScholarships,
    know: PennsylvaniaKnowMore,
    recruiters: PennsylvaniaRecruiter,
  },
  {
    pathname: "chicago",
    banner: ChicagoBanner,
    info: ChicagoInfo,
    choose: ChicagoChoose,
    fee: ChicagoFeeStructure,
    scholarship: ChicagoScholarships,
    know: ChicagoKnowMore,
    recruiters: ChicagoRecruiter,
  },
  {
    pathname: "mit",
    banner: MITBanner,
    info: MITInfo,
    choose: MITChoose,
    fee: MITFeeStructure,
    scholarship: MITScholarships,
    know: MITKnowMore,
    recruiters: MITRecruiter,
  },

  //UK

  {
    pathname: "bristol",
    banner: BristolBanner,
    info: BristolInfo,
    choose: BristolChoose,
    fee: BristolFeeStructure,
    scholarship: BristolScholarships,
    know: BristolKnowMore,
    recruiters: BristolRecruiter,
  },
  {
    pathname: "leeds",
    banner: LeedsBanner,
    info: LeedsInfo,
    choose: LeedsRankings,
    fee: LeedsFeeStructure,
    scholarship: LeedsScholarships,
    know: LeedsKnowMore,
    recruiters: LeedsRecruiter,
  },
  {
    pathname: "glasgow",
    banner: GlasgowBanner,
    info: GlasgowInfo,
    choose: GlasgowRankings,
    fee: GlasgowFeeStructure,
    scholarship: GlasgowScholarships,
    know: GlasgowKnowMore,
    recruiters: GlasgowRecruiter,
  },
  {
    pathname: "birmingham",
    banner: BirminghamBanner,
    info: BirminghamInfo,
    choose: BirminghamRankings,
    fee: BirminghamFeeStructure,
    scholarship: BirminghamScholarships,
    know: BirminghamKnowMore,
    recruiters: BirminghamRecruiter,
  },
  {
    pathname: "imperial",
    banner: ImperialBanner,
    info: ImperialInfo,
    choose: ImperialRankings,
    fee: ImperialFeeStructure,
    scholarship: ImperialScholarships,
    know: ImperialKnowMore,
    recruiters: imperialRecruiter,
  },
  {
    pathname: "queenmary",
    banner: QueenMaryBanner,
    info: QueenMaryInfo,
    choose: QueenMaryRankings,
    fee: QueenMaryFeeStructure,
    scholarship: QueenMaryScholarships,
    know: QueenMaryKnowMore,
    recruiters: QueenMaryRecruiter,
  },
  {
    pathname: "liverpool",
    banner: LiverpoolBanner,
    info: LiverpoolInfo,
    choose: LiverpoolRankings,
    fee: LiverpoolFeeStructure,
    scholarship: LiverpoolScholarships,
    know: LiverpoolKnowMore,
    recruiters: LiverpoolRecruiter,
  },
  {
    pathname: "edinburgh",
    banner: EdinburghBanner,
    info: EdinburghInfo,
    choose: EdinburghRankings,
    fee: EdinburghFeeStructure,
    scholarship: EdinburghScholarships,
    know: EdinburghKnowMore,
    recruiters: EdinburghRecruiter,
  },
  {
    pathname: "southampton",
    banner: SouthamptonBanner,
    info: SouthamptonInfo,
    choose: SouthamptonRankings,
    fee: SouthamptonFeeStructure,
    scholarship: SouthamptonScholarships,
    know: SouthamptonKnowMore,
    recruiters: SouthamptonRecruiter,
  },
  {
    pathname: "durham",
    banner: DurhamBanner,
    info: DurhamInfo,
    choose: DurhamRankings,
    fee: DurhamFeeStructure,
    scholarship: DurhamScholarships,
    know: DurhamKnowMore,
    recruiters: DurhamRecruiter,
  },

  // Australia Universities
  {
    pathname: "unsw",
    banner: UNSWBanner,
    recruiters: UNSWRecruiter,
    know: UNSWKnowMore,
    info: UNSWInfo,
    fee: UNSWFeeStructure,
    scholarship: UNSWScholarships,
    choose: UNSWRankings,
  },
  {
    pathname: "monash",
    banner: MonashBanner,
    recruiters: MonashRecruiter,
    know: MonashKnowMore,
    info: MonashInfo,
    fee: MonashFeeStructure,
    scholarship: MonashScholarships,
    choose: MonashRankings,
  },
  {
    pathname: "uq",
    banner: QueenslandBanner,
    recruiters: QueenslandRecruiter,
    know: QueenslandKnowMore,
    info: QueenslandInfo,
    fee: UQFeeStructure,
    choose: QueenslandRankings,
    scholarship: QueenslandScholarships,
  },
  {
    pathname: "uwa",
    banner: WesternaustraliaBanner,
    recruiters: WesternAustraliaRecruiter,
    know: WesternAustraliaKnowMore,
    info: UWAInfo,
    fee: WesternAustraliaFeeStructure,
    choose: WesternAustraliaRankings,
    scholarship: UWAScholarships,
  },
  {
    pathname: "adelaide",
    banner: AdelaideBanner,
    recruiters: AdelaideRecruiter,
    know: AdelaideKnowMore,
    info: AdelaideInfo,
    fee: AdelaideFeeStructure,
    choose: AdelaideRankings,
    scholarship: AdelaideScholarships,
  },
  {
    pathname: "melbourne",
    banner: MelbourneBanner,
    recruiters: MelbourneRecruiter,
    know: MelbourneKnowMore,
    info: MelbourneInfo,
    fee: MelbourneFeeStructure,
    choose: MelbourneRankings,
    scholarship: MelbourneScholarships,
  },
  {
    pathname: "sydeny",
    banner: SydneyBanner,
    recruiters: SydneyRecruiter,
    know: SydneyKnowMore,
    info: SydneyInfo,
    fee: SydneyFeeStructure,
    choose: SydneyRankings,
    scholarship: SydneyScholarships,
  },
  {
    pathname: "anu",
    banner: AnuBanner,
    recruiters: AnuRecruiter,
    know: ANUKnowMore,
    info: ANUInfo,
    fee: ANUFeeStructure,
    choose: ANURankings,
    scholarship: ANUScholarships,
  },
  {
    pathname: "uts",
    banner: TechnologySydneyBanner,
    recruiters: UtsRecruiter,
    know: UTSKnowMore,
    info: UTSInfo,
    fee: UTSFeeStructure,
    choose: UTSRankings,
    scholarship: UTSScholarships,
  },
  {
    pathname: "macquarie",
    banner: MacquarieBanner,
    recruiters: MacquarieRecruiter,
    know: MacquarieKnowMore,
    info: MacquarieInfo,
    fee: MacquarieFeeStructure,
    choose: MacquarieRankings,
    scholarship: MacquarieScholarships,
  },
  //Canada University
  {
    pathname: "trent",
    banner: TrentBanner,
    recruiters: TrentRecruiter,
    know: TrentKnowMore,
    info: TrentInfo,
    fee: TrentFeeStructure,
    choose: trentRankings,
    scholarship: TrentScholarships,
  },

  {
    pathname: "trinity",
    banner: TrinityBanner,
    recruiters: TrinityRecruiter,
    know: TrinityKnowMore,
    info: TrinityInfo,
    fee: TrinityFeeStructure,
    choose: TrinityRankings,
    scholarship: TrinityScholarships,
  },
  {
    pathname: "royal",
    banner: RRUBanner,
    recruiters: RRURecruiter,
    know: RoyalRoadsKnowMore,
    info: RRUInfo,
    fee: RRUFeeStructure,
    choose: RRURankings,
    scholarship: RoyalScholarships,
  },
  {
    pathname: "waterloo",
    banner: WaterlooBanner,
    recruiters: WaterlooRecruiter,
    know: WaterlooKnowMore,
    info: WaterlooInfo,
    fee: WaterlooFeeStructure,
    choose: WaterlooRankings,
    scholarship: WaterlooScholarships,
  },
  {
    pathname: "calgary",
    banner: CalgeryBanner,
    recruiters: CalgeryRecruiter,
    know: CalgaryKnowMore,
    info: CalgaryInfo,
    fee: CalgeryFeeStructure,
    choose: CalgeryRankings,
    scholarship: CalgeryScholarships,
  },
  {
    pathname: "dalhousie",
    banner: DalhousieBanner,
    recruiters: DalhousieRecruiter,
    know: DalhousieKnowMore,
    info: DalhousieInfo,
    fee: DalhousieFeeStructure,
    choose: DalhousieRankings,
    scholarship: DalhousieScholarships,
  },
  {
    pathname: "brock",
    banner: BrockBanner,
    recruiters: BrockRecruiter,
    know: BrockKnowMore,
    info: BrockInfo,
    fee: BrockFeeStructure,
    choose: BrockRankings,
    scholarship: BrockScholarships,
  },
  {
    pathname: "windsor",
    banner: WindsorBanner,
    recruiters: WindsorRecruiter,
    know: WindsorKnowMore,
    info: WindsorInfo,
    fee: WindsorFeeStructure,
    choose: WindsorRankings,
    scholarship: WindsorScholarships,
  },
  {
    pathname: "vcc",
    banner: VCCBanner,
    recruiters: VCCRecruiter,
    know: VCCKnowMore,
    info: VCCInfo,
    fee: VCCFeeStructure,
    choose: VCCProfile,
    scholarship: VCCScholarships,
  },
  {
    pathname: "toronto",
    banner: TorontoBanner,
    recruiters: TorontoRecruiter,
    know: TorontoKnowMore,
    info: TorontoInfo,
    fee: TorontoFeeStructure,
    choose: TorontoRankings,
    scholarship: TorontoScholarships,
  },

  // Germany

  {
    pathname: "lmum",
    banner: LMUBanner,
    recruiters: LMURecruiter,
    know: LMUKnowMore,
    info: LMUInfo,
    fee: LMUFeeStructure,
    choose: LMURankings,
    scholarship: LMUScholarships,
  },

  {
    pathname: "tum",
    banner: TMUBanner,
    recruiters: TUMRecruiter,
    know: TUMKnowMore,
    info: TUMInfo,
    fee: TUMFeeStructure,
    choose: TUMRankings,
    scholarship: TUMScholarships,
  },

  {
    pathname: "heidelberguniversity",
    banner: HeidelbergUniversityBanner,
    recruiters: HeidelbergUniversityRecruiter,
    know: HeidelbergUniversityKnowMore,
    info: HeidelbergUniversityInfo,
    fee: HeidelbergUniversityFeeStructure,
    choose: HeidelbergUniversityRankings,
    scholarship: HeidelbergUniversityScholarships,
  },

  {
    pathname: "humboldtuniversity",
    banner: HumboldtUniversityBanner,
    recruiters: HumboldtUniversityRecruiter,
    know: HumboldtUniversityKnowMore,
    info: HumboldtUniversityInfo,
    fee: HumboldtUniversityFeeStructure,
    choose: HumboldtUniversityRankings,
    scholarship: HumboldtUniversityScholarships,
  },

  {
    pathname: "freieuniversitätberlin",
    banner: FUBBanner,
    recruiters: FUBRecruiter,
    know: FUBerlinKnowMore,
    info: FUBInfo,
    fee: FUBFeeStructure,
    choose: FUBRankings,
    scholarship: FUBScholarships,
  },

  {
    pathname: "rwth",
    banner: RWTHBanner,
    recruiters: RWTHRecruiter,
    know: RWTHAachenKnowMore,
    info: RWTHInfo,
    fee: RWTHFeeStructure,
    choose: RWTHRankings,
    scholarship: RWTHScholarships,
  },

  {
    pathname: "universityoffreiburg",
    banner: UOFBanner,
    recruiters: UOFRecruiter,
    know: UOFKnowMore,
    info: UOFInfo,
    fee: UOFFeeStructure,
    choose: UOFRankings,
    scholarship: UOFScholarships,
  },
  {
    pathname: "universityoftübingen",
    banner: UOTBanner,
    recruiters: UOTRecruiter,
    know: UOTKnowMore,
    info: UOTInfo,
    fee: UOTFeeStructure,
    choose: UOTRankings,
    scholarship: UOTScholarships,
  },
  {
    pathname: "universityofmannheim",
    banner: UOMBanner,
    recruiters: UOMRecruiter,
    know: UOMKnowMore,
    info: UOMInfo,
    fee: UOMFeeStructure,
    choose: UOMRankings,
    scholarship: UOMScholarships,
  },
  {
    pathname: "universityofgöttingen",
    banner: UOGBanner,
    recruiters: UOGRecruiter,
    know: UOGKnowMore,
    info: UOGInfo,
    fee: UOGFeeStructure,
    choose: UOGRankings,
    scholarship: UOGScholarships,
  },

  //France

  {
    pathname: "upsl",
    banner: UPSLBanner,
    recruiters: UPSLRecruiter,
    know: UPSLKnowMore,
    info: UPSLInfo,
    fee: UPSLFeeStructure,
    choose: UPSLRankings,
    scholarship: UPSLScholarships,
  },
  {
    pathname: "paris-saclay",
    banner: UPSBanner,
    recruiters: UPSRecruiter,
    know: UPSKnowMore,
    info: UPSInfo,
    fee: UPSFeeStructure,
    choose: UPSRankings,
    scholarship: UPSScholarships,
  },

  {
    pathname: "sorbonne",
    banner: SUBanner,
    recruiters: SURecruiter,
    know: SUKnowMore,
    info: SUInfo,
    fee: SUFeeStructure,
    choose: SURankings,
    scholarship: SUScholarships,
  },

  {
    pathname: "uga",
    banner: UGABanner,
    recruiters: UGARecruiter,
    know: UGAKnowMore,
    info: UGAInfo,
    fee: UGAFeeStructure,
    choose: UGARankings,
    scholarship: UGAScholarship,
  },
  {
    pathname: "strasboury",
    banner: UDSBanner,
    recruiters: UDSRecruiter,
    know: UDSKnowMore,
    info: UDSInfo,
    fee: UDSFeeStructure,
    choose: UDSRankings,
    scholarship: UDSScholarships,
  },

  {
    pathname: "udm",
    banner: UDMBanner,
    recruiters: UDMRecruiter,
    know: UDMKnowMore,
    info: UDMInfo,
    fee: UDMFeeStructure,
    choose: UDMRankings,
    scholarship: UDMScholarships,
  },
  {
    pathname: "udl",
    banner: UDLBanner,
    recruiters: UDLRecruiter,
    know: UDLKnowMore,
    info: UDLInfo,
    fee: UDLFeeStructure,
    choose: UDLRankings,
    scholarship: UDLScholarships,
  },
  {
    pathname: "udn",
    banner: UDNBanner,
    recruiters: UDNRecruiter,
    know: UDNKnowMore,
    info: UDNInfo,
    fee: UDNFeeStructure,
    choose: UDNRankings,
    scholarship: UDNScholarships,
  },
  {
    pathname: "udb",
    banner: UDBBanner,
    recruiters: UDBRecruiter,
    know: UDBKnowMore,
    info: UDBInfo,
    fee: UDBFeeStructure,
    choose: UDBRankings,
    scholarship: UDBScholarships,
  },
  {
    pathname: "upps",
    banner: UPPSBanner,
    recruiters: UPPSRecruiter,
    know: UPPSKnowMore,
    info: UPPSInfo,
    fee: UPPSFeeStructure,
    choose: UPPSRankings,
    scholarship: UPPSScholarships,
  },

  //Italy

  {
    pathname: "pdmilano",
    banner: PDMilanoBanner,
    recruiters: PDMilanoRecruiter,
    know: PDMilanoKnowMore,
    info: PDMilanoiInfo,
    fee: PDMilanoFeeStructure,
    choose: PDMilanoChooseUs,
    scholarship: PDMilanoScholarships,
  },
  {
    pathname: "uomilano",
    banner: UOMilanBanner,
    recruiters: UOMilanRecruiter,
    know: UOMilanKnowMore,
    info: UOMilanInfo,
    fee: UOMilanFeeStructure,
    choose: UOMilanChooseUs,
    scholarship: UOMilanScholarships,
  },
  {
    pathname: "uobologna",
    banner: UOBolognaBanner,
    recruiters: UOBolognaRecruiter,
    know: UOBolognaKnowMore,
    info: UniboInfo,
    fee: UOBolognaFeeStructure,
    choose: UOBolognaChooseUs,
    scholarship: UOBolognaScholarships,
  },
  {
    pathname: "uoflorence",
    banner: UOFlorenceBanner,
    recruiters: UOFlorenceRecruiter,
    know: UOFlorenceKnowMore,
    info: UOFlorenceInfo,
    fee: UOFlorenceFeeStructure,
    choose: UOFlorenceChooseUs,
    scholarship: UOFlorenceScholarships,
  },
  {
    pathname: "uopadua",
    banner: UOPaduaBanner,
    recruiters: UOPaduaRecruiter,
    know: UOPaduaKnowMore,
    info: UOPaduaInfo,
    fee: UOPaduaFeeStructure,
    choose: UOPaduaChooseUs,
    scholarship: UOPaduaScholarships,
  },
  {
    pathname: "uoturin",
    banner: UOTurinBanner,
    recruiters: UOTurinRecruiter,
    know: UOTurinKnowMore,
    info: UOTurinInfo,
    fee: UOTurinFeeStructure,
    choose: UOTurinChooseUs,
    scholarship: UOTurinScholarships,
  },
  {
    pathname: "rome-la-sapienza",
    banner: RLSBanner,
    recruiters: RLSRecruiter,
    know: RLSKnowMore,
    info: RLSInfo,
    fee: RLSFeeStructure,
    choose: RLSChooseUs,
    scholarship: RLSScholarships,
  },
  {
    pathname: "uonaples",
    banner: UONaplesBanner,
    recruiters: UONaplesRecruiter,
    know: UONaplesKnowMore,
    info: UONaplesInfo,
    fee: UONaplesFeeStructure,
    choose: UONaplesChooseUs,
    scholarship: UONaplesScholarships,
  },
  {
    pathname: "uopisa",
    banner: UOPisaBanner,
    recruiters: UOPisaRecruiter,
    know: UOPisaKnowMore,
    info: UOPisaInfo,
    fee: UOPisaFeeStructure,
    choose: UOPisaChooseUs,
    scholarship: UOPisaScholarships,
  },
  {
    pathname: "ied",
    banner: IEDBanner,
    recruiters: IEDRecruiter,
    know: IEDKnowMore,
    info: IEDInfo,
    fee: IEDFeeStructure,
    choose: IEDChooseUs,
    scholarship: IEDScholarships,
  },

  //Ireland

  {
    pathname: "tdublin",
    banner: TCDublinBanner,
    recruiters: TCDublinRecruiter,
    know: TCDublinKnowMore,
    info: TCDublinInfo,
    fee: TCDublinFeeStructure,
    choose: TCDublinChooseUs,
    scholarship: TCDublinScholarships,
  },
  {
    pathname: "ucdublin",
    banner: UCDublinBanner,
    recruiters: UCDublinRecruiter,
    know: UCDublinKnowMore,
    info: UCDublinInfo,
    fee: UCDublinFeeStructure,
    choose: UCDublinChooseUs,
    scholarship: UCDublinScholarships,
  },
  {
    pathname: "uocork",
    banner: UOCorkBanner,
    recruiters: UOCorkRecruiter,
    know: UOCorkKnowMore,
    info: UOCorkInfo,
    fee: UCCorkFeeStructure,
    choose: UOCorkChooseUs,
    scholarship: UOCorkScholarships,
  },
  {
    pathname: "uogalway",
    banner: UOGalwayBanner,
    recruiters: UOGalwayRecruiter,
    know: UOGalwayKnowMore,
    info: UOGalwayInfo,
    fee: UOGalwayFeeStructure,
    choose: UOGalwayChooseUs,
    scholarship: UOGalwayScholarships,
  },
  {
    pathname: "dcu",
    banner: DCUBanner,
    recruiters: DCURecruiter,
    know: DCUKnowMore,
    info: DCUInfo,
    fee: DCUFeeStructure,
    choose: DCUChooseUs,
    scholarship: DCUScholarships,
  },
  {
    pathname: "uolimerick",
    banner: UOLimerickBanner,
    recruiters: UOLimerickRecruiter,
    know: UOLimerickKnowMore,
    info: UOLimerickInfo,
    fee: UOLimerickFeeStructure,
    choose: UOLimerickChooseUs,
    scholarship: UOLimerickScholarships,
  },
  {
    pathname: "mu",
    banner: MUBanner,
    recruiters: MURecruiter,
    know: MUKnowMore,
    info: MUInfo,
    fee: MUFeeStructure,
    choose: MUChooseUs,
    scholarship: MUScholarships,
  },
  {
    pathname: "tudublin",
    banner: TUDublinBanner,
    recruiters: TUDublinRecruiter,
    know: TUDublinKnowMore,
    info: TUDublinInfo,
    fee: TUDublinFeeStructure,
    choose: TUDublinChooseUs,
    scholarship: TUDublinScholarships,
  },
  {
    pathname: "dbs",
    banner: DBSBanner,
    recruiters: DBSRecruiter,
    know: DBSKnowMore,
    info: DBSInfo,
    fee: DBSFeeStructure,
    choose: DBSChooseUs,
    scholarship: DBSScholarships,
  },
  {
    pathname: "rcsi",
    banner: RCSIBanner,
    recruiters: RCSIRecruiter,
    know: RCSIKnowMore,
    info: RCSInfo,
    fee: RCSFeeStructure,
    choose: RCSChooseUs,
    scholarship: RCSScholarships,
  },

  //New-Zealand

  {
    pathname: "uoa",
    banner: UOABanner,
    recruiters: AucklandRecruiter,
    know: AucklandKnowMore,
    info: UoAInfo,
    fee: UOAFeeStructure,
    choose: UniversityAucklandRankings,
    scholarship: AucklandScholarships,
  },
  {
    pathname: "muniversity",
    banner: MUniversityBanner,
    recruiters: MasseyRecruiter,
    know: MasseyKnowMore,
    info: MasseyInfo,
    fee: MUniversityFeeStructure,
    choose: universityMasseyRankings,
    scholarship: MasseyScholarships,
  },
  {
    pathname: "uwaikato",
    banner: UOWBanner,
    recruiters: WaikatoRecruiter,
    know: WaikatoKnowMore,
    info: WaikatoInfo,
    fee: UOWFeeStructure,
    choose: WaikatouniversityRankings,
    scholarship: WaikatoScholarships,
  },
  {
    pathname: "vuow",
    banner: VUOWBanner,
    recruiters: VictoriaRecruiter,
    know: VictoriaKnowMore,
    info: VUWInfo,
    fee: VUOWFeeStructure,
    choose: VictoriauniversityRankings,
    scholarship: VictoriaScholarships,
  },
  {
    pathname: "uoc",
    banner: UCanterburyBanner,
    recruiters: CanterburyRecruiter,
    know: CanterburyKnowMore,
    info: CanterburyInfo,
    fee: UCanterburyFeeStructure,
    choose: CanterburyuniversityRankings,
    scholarship: CanterburyScholarships,
  },
  {
    pathname: "uoo",
    banner: UOtagoBanner,
    recruiters: OtagoRecruiter,
    know: OtagoKnowMore,
    info: OtagoInfo,
    fee: UOtagoFeeStructure,
    choose: OtagouniversityRankings,
    scholarship: OtagoScholarships,
  },
  {
    pathname: "auot",
    banner: AUOTBanner,
    recruiters: AUTRecruiter,
    know: AUTKnowMore,
    info: AUTInfo,
    fee: AUOTFeeStructure,
    choose: AucklanduniversityRankings,
    scholarship: AUTScholarships,
  },
  {
    pathname: "luniversity",
    banner: LUniversityBanner,
    recruiters: LincolnRecruiter,
    know: LincolnKnowMore,
    info: LincolnInfo,
    fee: LUniversityFeeStructure,
    choose: LincolnuniversityRankings,
    scholarship: LincolnScholarships,
  },
  {
    pathname: "eiot",
    banner: EIOTBanner,
    recruiters: EITRecruiter,
    know: EITKnowMore,
    info: EITInfo,
    fee: EIOTFeeStructure,
    choose: EasternpolytechnicRankings,
    scholarship: EITScholarships,
  },
  {
    pathname: "ucic",
    banner: UCICBanner,
    recruiters: UCRecruiters,
    know: UCICKnowMore,
    info: UCICInfo,
    fee: UCICFeeStructure,
    choose: UCICRankings,
    scholarship: UCScholarships,
  },

  //SINGAPOR

  {
    pathname: "nuos",
    banner: NUSBanner,
    recruiters: NUSRecruiters,
    know: NUSKnowMore,
    info: NUSInfo,
    fee: NUSFeeStructure,
    choose: NUSRankings,
    scholarship: NUSScholarships,
  },
  {
    pathname: "ntus",
    banner: NTUBanner,
    recruiters: NTURecruiters,
    know: NTUKnowMore,
    info: NTUInfo,
    fee: NTUFeeStructure,
    choose: NTURankings,
    scholarship: NTUScholarships,
  },
  {
    pathname: "sutd",
    banner: SUTDBanner,
    recruiters: SUTDRecruiters,
    know: SUTDKnowMore,
    info: SUTDInfo,
    fee: SUTDFeeStructure,
    choose: SUTDRankings,
    scholarship: SUTDScholarships,
  },
  {
    pathname: "smu",
    banner: SMBanner,
    recruiters: SMRecruiters,
    know: SMUKnowMore,
    info: SMInfo,
    fee: SMFeeStructure,
    choose: SMRankings,
    scholarship: SMScholarships,
  },
  {
    pathname: "jcu",
    banner: JCBanner,
    recruiters: JCRecruiters,
    know: JCUNowMore,
    info: JCInfo,
    fee: JCFeeStructure,
    choose: JCRankings,
    scholarship: JCScholarships,
  },
  {
    pathname: "mdis",
    banner: MDISBanner,
    recruiters: MDISRecruiters,
    know: MDISKnowMore,
    info: MDISInfo,
    fee: MDISFeeStructure,
    choose: MDISRankings,
    scholarship: MDISScholarships,
  },
  {
    pathname: "sim",
    banner: SIMGEBanner,
    recruiters: SIMGERecruiters,
    know: SIMKnowMore,
    info: SIMGEInfo,
    fee: SIMGEFeeStructure,
    choose: SIMGERankings,
    scholarship: SIMGEScholarships,
  },
  {
    pathname: "rche",
    banner: RCHEBanner,
    recruiters: RCHERecruiters,
    know: RafflesKnowMore,
    info: RCOHInfo,
    fee: RCHEFeeStructure,
    choose: RCHERankings,
    scholarship: RCHEScholarships,
  },
  {
    pathname: "erau",
    banner: ERABanner,
    recruiters: ERARecruiters,
    know: ERAUAsiaKnowMore,
    info: ERAInfo,
    fee: ERAFeeStructure,
    choose: ERARankings,
    scholarship: ERAScholarships,
  },
  {
    pathname: "cs",
    banner: CSBanner,
    recruiters: CSRecruiters,
    know: CurtinSingaporeKnowMore,
    info: CSInfo,
    fee: CSFeeStructure,
    choose: CSRankings,
    scholarship: CSScholarships,
  },

  //Singapur

  //UAE
  {
    pathname: "cud",
    banner: CUDBanner,
    recruiters: CUDRecruiter,
    know: CUDKnowMore,
    info: CUDInfo,
    fee: CUDFeeStructure,
    choose: CUDRankings,
    scholarship: CUDScholarships,
  },
  {
    pathname: "au",
    banner: AjmanBanner,
    recruiters: AjmanRecruiter,
    know: AjmanKnowMore,
    info: AjmanInfo,
    fee: AjmanFeeStructure,
    choose: AjmanRankings,
    scholarship: AjmanScholarships,
  },
  {
    pathname: "adu",
    banner: AbuDhabiBanner,
    recruiters: AbutDhabiRecruiter,
    know: AbuDhabiKnowMore,
    info: AbuDhabiInfo,
    fee: AbutDhabiFeeStructure,
    choose: AbuDhabiRankings,
    scholarship: AbuDhabiScholarships,
  },
  {
    pathname: "aurak",
    banner: AURAKBanner,
    recruiters: AURAKRecruiter,
    know: AURAKKnowMore,
    info: AURAKInfo,
    fee: AURAKFeeStructure,
    choose: AURAKRankings,
    scholarship: AURAKScholarships,
  },
  {
    pathname: "uaeu",
    banner: UAEUBanner,
    recruiters: UAEURecruiter,
    know: UAEUKnowMore,
    info: UAEUInfo,
    fee: UAEUFeeStructure,
    choose: UAEURankings,
    scholarship: UAEUScholarships,
  },
  {
    pathname: "khalifa",
    banner: khalifaBanner,
    recruiters: KhalifaRecruiter,
    know: KhalifaKnowMore,
    info: KhalifaInfo,
    fee: KhalifaFeeStructure,
    choose: KhalifaRankings,
    scholarship: KhalifaScholarships,
  },
  {
    pathname: "auos",
    banner: AUSBanner,
    recruiters: AUSRecruiter,
    know: AUSKnowMore,
    info: AUSInfo,
    fee: AUSFeeStructure,
    choose: AUSRankings,
    scholarship: AUSScholarships,
  },
  {
    pathname: "aau",
    banner: ALAinBanner,
    recruiters: AlAinFRecruiter,
    know: AlAinKnowMore,
    info: ALAinInfo,
    fee: AlAinFeeStructure,
    choose: ALAinRankings,
    scholarship: AlAinScholarships,
  },
  {
    pathname: "zu",
    banner: ZayedUniversityBanner,
    recruiters: ZayedUniversityRecruiter,
    know: ZayedUniversityKnowMore,
    info: ZayedUniversityInfo,
    fee: ZayedUniversityFeeStructure,
    choose: ZayedUniversityRankings,
    scholarship: ZayedUniversityScholarships,
  },
  {
    pathname: "uod",
    banner: UniversityOfDubaiBanner,
    recruiters: UniversityOfDubaiRecruiter,
    know: UniversityOfDubaiKnowMore,
    info: UniversityOfDubaiInfo,
    fee: UniversityOfDubaiFeeStructure,
    choose: UniversityOfDubaiRankings,
    scholarship: UniversityOfDubaiScholarships,
  },
];
const UniversityPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { pageName } = useParams();
  const [pageData, setPageData] = useState(null);

  useEffect(() => {
    const currentPageData = jsonData.find(
      (data) => data?.pathname === pageName
    );
    setPageData(currentPageData);
  }, [pageName]);
  return (
    <>
      <Navbar />
      {pageData?.banner && <Universitybanner data={pageData.banner} />}
      <BackRouteContainer
        logo={logo}
        path={-1}
        title={"Select University Page"}
      />
      {pageData?.info && <UniversityInfo data={pageData.info} />}
      {pageData?.choose && <WhyChooseUniversity data={pageData.choose} />}
      {pageData?.fee && <UniversityFeeStructure data={pageData.fee} />}
      {pageData?.scholarship && (
        <UniversityScholarship data={pageData.scholarship} />
      )}
      {pageData?.recruiters && (
        <UniversityRecruiters data={pageData.recruiters} />
      )}
      {pageData?.know && <UniversityKnowMore data={pageData.know} />}
      <BackRouteContainer
        logo={logo}
        path={-1}
        title={"Select University Page"}
      />
      <LetsGetStarted />
      <Footer />
    </>
  );
};

export default UniversityPage;
